import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { PagedRawImageDetailModel } from 'src/app/editor/models/paged.raw.image.detail.model';
import { RawImageService } from 'src/app/editor/services/raw.image.service';
import { AppUtils } from 'src/app/helpers/app.utils';
import { PageUrls } from 'src/app/helpers/page-urls';
import { TableModel } from 'src/app/models/table.model';

@Component({
    selector: 'app-raw-image-manage-grouped',
    templateUrl: './raw.image.manage.component.html',
    styleUrls: ['./raw.image.manage.component.scss']
})
export class RawImageManageComponent implements OnInit {

    unixTimeStamp: number;
    tableModel: TableModel;
    totalRecords: number;
    selectedAll = false;
    selectedTotalRecords = false;
    showMarkAsProcessed = false;
    private subscriptions: Subscription[];
    pagedRawImageDetail = new PagedRawImageDetailModel();

    constructor(private router: Router,
        private route: ActivatedRoute,
        private rawImageService: RawImageService,
        private toatsr: ToastrService,
        private ngxSpinner: NgxSpinnerService) {
        this.route.queryParams.subscribe(params => {
            this.unixTimeStamp = params['unixTimeStamp'];
        });
    }
    ngOnInit(): void {
        this.tableModel = new TableModel();
        this.totalRecords = 0;
        this.subscriptions = [];
        this.initSubscribers();
        this.getRawImages();
    }

    initSubscribers() {
        const subscription = this.tableModel.pageChanged.subscribe(() => this.getRawImages());
        this.subscriptions.push(subscription);
    }

    selectAll() {
        this.pagedRawImageDetail.items.forEach(element => {
            element.isSelected = this.selectedAll;
            this.showMarkAsProcessed = this.selectedAll;
        });
    }

    selectTotalRecords() {
        this.selectedAll = this.selectedTotalRecords;
        this.selectAll();
    }

    updateSelectAll() {
        const selectedImageList = this.pagedRawImageDetail.items.filter(x => x.isSelected);
        if (selectedImageList.length !== this.pagedRawImageDetail.items.length) {
            this.selectedAll = false;
        } else {
            this.selectedAll = true;
        }
        if (selectedImageList.length !== 0) {
            this.showMarkAsProcessed = true;
        } else {
            this.showMarkAsProcessed = false;
        }
    }

    getRawImages() {
        this.ngxSpinner.show();
        this.rawImageService.getList(this.unixTimeStamp, this.tableModel).subscribe(
            res => {
                this.ngxSpinner.hide();
                this.pagedRawImageDetail = res;
                this.selectedAll = this.selectedTotalRecords;
                if (!this.pagedRawImageDetail || this.pagedRawImageDetail.totalCount === 0) {
                    this.router.navigateByUrl(`/${PageUrls.Editor.PendingGrouped}`);
                } else {
                    this.selectAll();
                    this.totalRecords = this.pagedRawImageDetail.totalCount;
                }
            }, error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toatsr, error);
            });
    }

    markAsProcessed() {
        if (!confirm('Are you sure you want to mark these images as processed?')) {
            return;
        }
        const rawImageIds = new Array<string>();

        this.ngxSpinner.show();
        if (this.selectedTotalRecords && this.totalRecords > this.tableModel.pageSize) {
            this.tableModel.pageSize = this.totalRecords;
            this.rawImageService.getList(this.unixTimeStamp, this.tableModel).subscribe(
                res => {
                    res.items.forEach(element => {
                        rawImageIds.push(element.id);
                    });
                    this.processImages(rawImageIds);
                }, error => {
                    this.ngxSpinner.hide();
                    AppUtils.processErrorResponse(this.toatsr, error);
                });
        } else {
            this.pagedRawImageDetail.items.forEach(element => {
                if (element.isSelected) {
                    rawImageIds.push(element.id);
                }
            });
            if (rawImageIds.length === 0) {
                this.ngxSpinner.hide();
                return;
            }
            this.processImages(rawImageIds);
        }

    }

    processImages(rawImageIds: any) {
        this.rawImageService.markAsProcessed(rawImageIds).subscribe(
            () => {
                this.ngxSpinner.hide();
                this.getRawImages();
                this.toatsr.success('Images have been processed successfully.');
            }, error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toatsr, error);
            });
    }
}
